import createIcon from '../../createIcon';

/**
 * @component @name Timer
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMS41SDlWMy41SDE1VjEuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOS4wMyA3Ljg5TDIwLjQ1IDYuNDdDMjAuMDIgNS45NiAxOS41NSA1LjQ4IDE5LjA0IDUuMDZMMTcuNjIgNi40OEMxNi4wNyA1LjI0IDE0LjEyIDQuNSAxMiA0LjVDNy4wMyA0LjUgMyA4LjUzIDMgMTMuNUMzIDE4LjQ3IDcuMDIgMjIuNSAxMiAyMi41QzE2Ljk4IDIyLjUgMjEgMTguNDcgMjEgMTMuNUMyMSAxMS4zOCAyMC4yNiA5LjQzIDE5LjAzIDcuODlaTTEzIDE0LjVIMTFWOC41SDEzVjE0LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Timer = createIcon('Timer', [
  ['path', { d: 'M15 1.5H9V3.5H15V1.5Z', key: '1njhq5' }],
  [
    'path',
    {
      d: 'M19.03 7.89L20.45 6.47C20.02 5.96 19.55 5.48 19.04 5.06L17.62 6.48C16.07 5.24 14.12 4.5 12 4.5C7.03 4.5 3 8.53 3 13.5C3 18.47 7.02 22.5 12 22.5C16.98 22.5 21 18.47 21 13.5C21 11.38 20.26 9.43 19.03 7.89ZM13 14.5H11V8.5H13V14.5Z',
      key: '1ntb2p',
    },
  ],
]);

export default Timer;
